export type AuthUrlParams = {
  forceLogin?: string;
  email?: string;
};
